<template>
  <div>
    <SignaturePad
      :showSignaturePad="showSignaturePad"
      @close="showSignaturePad = false"
      @signatureData="signatureData"
    />
    <v-card min-height="40vh">
      <v-col
        cols="12"
        class="white--text text-uppercase text-center text-caption"
        style="background-color: #2b3990; "
        >{{ title }}
      </v-col>
      <v-col cols="12" md="12">
        <p class="text-caption">
            During New Hire Training and Position Specific Training, new employees will receive several trainings as listed below.
            Until these trainings have been completed for new employees and as applicable over the course of their employment, field
            employees (i.e., Direct Care Associates, House Managers, Program Managers, Program Coordinators, and Region Directors)
            and administrative employees (as applicable) must <b> NEVER </b> work unsupervised with {{ userCompany }} clients at any point
            in their employment until the following certifications/trainings have been completed and the associated documentation has been
            submitted to the Human Resources Department <b> (R501-1-14. Residential Program Additional Administration and Direct Services Requirements.): </b>
        </p>
        <p class="text-caption">
         <b>
            1. Cleared background check  <br />
            2. DHS Code of Conduct  <br />
            3. DSPD Code of Conduct  <br />
            4. Office of Licensing Code of Conduct and Client Rights Rule  <br />
            5. General Employee Training  <br />
            6. General Employee Training Competency Test  <br />
            7. Position-Specific Training  <br />
            8. Client-Specific Competency Test (aka clinical needs of each of the client) <br />
                a. Employees must complete a Client-Specific Competency Test for any clients they support
                prior to working unsupervised with a client. This includes any shift coverage in another program
                (e.g., all staff and day program employees must complete or each client in the program).  <br />
                b. Each employee's direct supervisor is responsible for ensuring that all employees who work in their program
                (or department, if applicable) have completed Client-Specific Competency Tests for each client in their program
                (or department, if applicable).  <br />
            9. Client Rights Training  <br />
            10. Incident Report Training  <br />
            11. Safety Care Training (all field and select admin employees only)  <br />
            12. CPR / First Aid / Choking Prevention Training (field and select admin employees only)  <br />
            13. I can NEVER drive any individuals without a valid DL, insurance and cleared MVR.  <br />
            14. I can NEVER take individuals to my personal residence for any reason or time frame.
        </b>
        </p>
        <p class="text-caption">
         Prior to completion of each of these certifications/trainings, employees providing direct care services to client
         must be supervised <b> at all times </b> by an employee who has completed each of these certifications / trainings.
        </p>
        <p class="text-caption">
         Each employee must track his or her own missing or soon-to-expire certifications. Employees can consult their direct
         supervisor if there are any questions regarding any missing or soon-to-expire certifications.
        </p>
         <p class="text-caption">
         <b> By signing below, I acknowledge that I have read and understand the information outlined on this form and agree
         to never work unsupervised with any clients prior to completing all of the certifications/trainings listed above, both
         upon being hired and as required for re-certifications purposes. I further agree to never allow employees I may supervise
         to work unsupervised with clients prior to completing all of the certifications/trainings listed above. </b>
        </p>


      </v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="item.employeeName"
              label="Employee Name (print)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <div style="position: relative">
              <v-text-field
                label="Employee's Signature"
                @click.stop="showSignaturePad = true"
              ></v-text-field>
              <v-img
                width="150"
                height="50"
                :src="employeeSignatureInRequiredCert"
                style="position:absolute;top:10px;right:150px;"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              ref="menu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.dateSignedInRequiredCert"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="item.dateSignedInRequiredCert"
                @input="dateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
           <v-col>
            <v-row align="center" justify="start">
              <v-card-actions>
                <v-btn @click="prev">Prev</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="end">
              <v-card-actions>
                <v-btn @click="next">Next</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </div>
</template>
<script>
/* eslint-disable */
import SignaturePad from "@/components/SignaturePad";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import download from "downloadjs";

export default {
  components: { SignaturePad },
  props: {
    title: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
    },
    currentStep: {
      type: Number,
    },
  },
  data: function() {
    return {
      dateMenu: false,
      employeeSignature: "",
      showSignaturePad: false,
      item: {},
      step: this.currentStep,
    };
  },

  created() {
    this.populateUserInfo();
    const savedSignature = localStorage.getItem("employeeSignatureInRequiredCert");
    if (savedSignature) {
      this.signatureData(savedSignature);
    }
  },

  computed: {
    ...mapGetters("userDocuments", ["getUserDocuments"]),
    ...mapGetters("users", {
      user: "user",
      userCompany: "userCompany",
    }),
  },

  methods: {
    ...mapActions({
      getDocuments: "userDocuments/getDocuments",
      addTransportationDoc: "userDocuments/saveTransportationDocument",
      addDocument: "userDocuments/updateDocument",
      downloadDocuments: "userDocuments/downloadDocuments",
    }),
    signatureData(data) {
      this.employeeSignatureInRequiredCert = data;
      localStorage.setItem("employeeSignatureInRequiredCert", data);
    },

    next() {
      this.addItem();
      // this.generatePDF();
      this.$emit("clicked", this.step + 1);
    },
    prev() {
      this.$emit("clicked", this.step - 1);
    },
    async addItem() {
      try {
        const response = await this.addDocument({
          data: { ...this.item, Employee: this.user._id },
          pdfDocument: "client-transportation-agreement",
        });
        console.log(response);
        localStorage.setItem('dateSignedInRequiredCert', this.item.dateSignedInRequiredCert);
      } catch (error) {
        console.log(error);
      }
    },

    async populateUserInfo() {

      if (localStorage.getItem('dateSignedInRequiredCert')) {
        this.item.dateSignedInRequiredCert = localStorage.getItem('dateSignedInRequiredCert');
      }

      this.item.employeeName = this.user.Name;

      const response = await this.getDocuments(this.user._id);

      let documents = this.updateCase(
        response.data.document.Documents.ClientTransportationAgreement
      );

      this.item = Object.assign(
        {},
        {
          ...documents,
          employeeName: response.data.document.Employee.Name,
          dateSignedInRequiredCert: this.item.dateSignedInRequiredCert,
        }
      );
    },

    async generatePDF() {
      const response = await this.downloadDocuments({
        id: this.user._id,
        pdfDocument: "client-transportation-agreement",
      });
      let pdfFile =
        "data:application/octet-stream;base64," + response.data.data;
      download(
        pdfFile,
        "client-transportation-agreement.pdf",
        "application/pdf"
      );
    },

    updateCase(obj) {
      let output = Object.entries(obj).map(([key, value]) => [
        key[0].toLowerCase() + key.slice(1),
        value,
      ]);
      return Object.fromEntries(output);
    },
  },
};
</script>
<style scoped>
.theme--light.v-btn.v-btn--has-bg {
  background-color: #2b3990;
  color: #fff;
  border-radius: 1.25rem;
}
</style>
